import * as $modal from './_modal'
import * as $loading from './_loading'
import * as $blogpostpopup from './blog.blogpostpopup'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    parentGuid: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $.extend(true, {}, $options)

    getList()

    $blogpostpopup.load(10)
}

export function getList(): void {
    $loading.show()

    elem('list').load(`/Account/ChildAccountsList?parent=${options.parentGuid}`, function () {
        $loading.hide()
    })
}

export function editModal(guid: string): void {
    $modal.load('/Account/ChildAccountEdit', { id: guid }, false, true, false)
}

function elem(id: string): JQuery {
    return $(`.${options.pagePrefix}-${id}`)
}
